import { useAtom, useAtomValue } from "jotai";
import { useRef } from "react";
import { Button } from "reactstrap";
import { Popover, Tooltip, Whisper, WhisperInstance } from "rsuite";
import { ScreenSizeAtom } from "../../../App";
import { activeLinkAtom, sidebarOpenAtom } from "../../../atoms/SidebarAtoms";
import SidebarIcon from "./SidebarIcon";

interface Props {
  customIcon?: string;
  iconURL?: string;
  icon?: string;
  isHovered?: boolean;
  linkId: string;
  options?: React.ReactNode;
  title: string;
}

const InnerLink = ({
  customIcon,
  iconURL,
  icon,
  isHovered,
  linkId,
  options,
  title,
}: Props) => {
  const [activeLink, setActiveLink] = useAtom(activeLinkAtom);
  const open = useAtomValue(sidebarOpenAtom);
  const screenSize = useAtomValue(ScreenSizeAtom);
  const whisperRef = useRef<WhisperInstance>(null);

  return open ? (
    <div className="tw:flex tw:items-center" style={{ zIndex: 3, height: 19 }}>
      {iconURL ? (
        <div
          className="d-inline-block"
          style={{
            width: "26px",
            height: "26px",
            position: "relative",
          }}
        >
          <SidebarIcon iconURL={iconURL} />
        </div>
      ) : (
        <i
          className={`${
            customIcon || (icon ? icon : "mdi mdi-file-table-box-outline")
          } pr-2`}
          style={{ fontSize: 18, width: 26 }}
        />
      )}
      <div
        className="text-truncate"
        style={{
          width:
            (isHovered || activeLink === linkId) && options
              ? "calc(100% - 50px)"
              : "calc(100% - 26px)",
        }}
      >
        {title}
      </div>
      {(isHovered || activeLink === linkId || screenSize === "xs") &&
        options && (
          <Whisper
            preventOverflow
            placement="autoVerticalStart"
            controlId=""
            trigger="click"
            ref={whisperRef}
            onClose={() => setActiveLink(null)}
            speaker={
              <Popover
                className="sidebar-popover"
                full
                onClick={(e: any) => {
                  e.stopPropagation();
                  whisperRef.current?.close();
                }}
              >
                {options}
              </Popover>
            }
          >
            <Button
              size="sm"
              outline
              color="secondary"
              className="btn-icon-only"
              onClick={handleOptionsOpen}
              style={{
                height: "1.5rem",
                width: "1.5rem",
              }}
            >
              <i className="mdi mdi-dots-horizontal" style={{ fontSize: 20 }} />
            </Button>
          </Whisper>
        )}
    </div>
  ) : (
    <Whisper
      placement="right"
      controlId={`tooltipHover${linkId}`}
      trigger="hover"
      speaker={<Tooltip>{title}</Tooltip>}
    >
      <div className="d-flex justify-content-center">{title.charAt(0)}</div>
    </Whisper>
  );

  function handleOptionsOpen(e: any) {
    e.stopPropagation();
    e.preventDefault();

    if (setActiveLink) {
      if (activeLink === linkId) {
        return setActiveLink(null);
      }

      setActiveLink(linkId);
    }
  }
};

export default InnerLink;
